import plugins from './plugins/plugins';
import { PROCESSING_ROUTES } from './app/modules/processing';

export default {
  build: {
    extend(config, ctx) {
      if (ctx.isDev) {
        config.devtool = ctx.isClient ? 'source-map' : 'inline-source-map';
      }
    },
  },
  head: {
    link: [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      { rel: 'icon', sizes: '16x16', href: '/favicon-16x16.png' },
      { rel: 'icon', sizes: '32x32', href: '/favicon-32x32.png' },
    ],
  },
  loading: '~/components/layout/loading',
  serverMiddleware: [{ path: '/proxy', handler: '~/server-middleware/proxy' }],
  modules: ['~/modules/arithmetic', '~/modules/debt-sold', '@sf/sandbox', '@sf/core', '@sf/lib'],
  plugins,
  css: ['~assets/global.scss'],
  core: {
    name: 'Manato.az',
    title: 'Sürətli və rahat onlayn kredit',
    description:
      'Bir neçə dəqiqə ərzində 500 AZN-dək sürətli və rahat onlayn kredit. Zaminsiz və girovsuz, tək şəxsiyyət vəsiqəsi ilə pulunuzu bank kartınıza əldə edin.',
    hostname: 'https://www.manato.az',
    gcm_sender_id: '103953800507',
    GTM: 'GTM-NWCTGBF',
    DSN: 'https://4d92345f5fd44ffeade3fe95db09b76d@sentry.sunfinance.ninja/91',
    languages: [{ code: 'az', iso: 'az' }, { code: 'ru', iso: 'ru' }],
    currency: { local: '₼', global: 'AZN' },
    fonts: {
      style: [['Montserrat', [400, 500, 600, 700, 900], true]],
      cyrillic: true,
    },
    affiliateCookiesMaxAge: 72 * 60 * 60, // 72 hours
  },
  i18n: {
    locales: [{ code: 'az', iso: 'az', file: 'az.js' }, { code: 'ru', iso: 'ru', file: 'ru.js' }],
    langDir: 'translations/',
    defaultLocale: 'az',
    detectBrowserLanguage: false,
    lazy: true,
    vueI18n: {
      fallbackLocale: 'ru',
      silentTranslationWarn: true,
      silentFallbackWarn: true,
    },
  },
  lib: {
    theme: 'alpha',
    components: [
      'button',
      'input',
      'form',
      'select',
      'checkbox',
      'mouse-distance-tracker',
      'mouse-time-tracker',
      'arithmetic-tracker',
      'contact-link',
      'header',
      'lang-switch',
      'drawer',
      'text-template',
      'collapse',
      'collapse-item',
      'slide-toggle',
      'tabs',
      'progress',
    ],
  },
  arithmetic: {
    getConfig: true,
  },
  router: {
    middleware: ['redirect'],
    extendRoutes(routes, resolve) {
      routes.push(
        ...PROCESSING_ROUTES.map(route => ({
          ...route,
          component: resolve(__dirname, route.component),
        }))
      );
    },
  },
};
